import { connect } from 'react-redux';

import ListComponent from './ListComponent';

const getSubtext = p => {
  return `${p.result} ${p.year}`;
};

const priceValue = {
  gull: 1,
  sølv: 2,
  bronse: 3,
  daguerreprisen: 4,
  'beste barnebilde': 5,
  laugskruset: 6,
};

const sortPrices = (a, b) => {
  if (a.year !== b.year) {
    return b.year - a.year;
  }
  const aPrice = priceValue[a.result.toLowerCase()] || 10;
  const bPrice = priceValue[b.result.toLowerCase()] || 10;
  return aPrice - bPrice;
};

const mapStateToProps = ({ photographers }, _) => {
  let prices = photographers.data.map(p =>
    p.prices.map(year =>
      year.result.map(r => ({
        photographerId: p.id,
        name: p.name,
        year: year.year,
        result: r,
      })),
    ),
  );

  prices = [].concat.apply([], prices);
  prices = [].concat.apply([], prices);

  return {
    title: 'Prisar i lauget',
    data: prices
      .map((p, i) => ({
        id: i,
        leftIcon: 'fa fa-user-o pr1',
        title: p.name || `${p.first_name} ${p.last_name}`,
        url: `/fotografer/${p.photographerId}`,
        year: p.year,
        result: p.result,
        subtext: getSubtext(p),
        // TODO: Add icon for gold, silver, bronze, oldermann
      }))
      .sort(sortPrices),
  };
};

export default connect(mapStateToProps)(ListComponent);



// WEBPACK FOOTER //
// ./src/pages/PricingList.js